<template>
  <div>

    <div class="container">

      <div class="home">
        <img class="hero-pic" src="../assets/boat-pic-1.jpg" alt="Fishing Boat">
        <h1>Welcome to Offshore SMS</h1>
        <h4>A learning resource to introduce new users to commercial vessel safety management systems and how to use Offshore SMS.</h4>
        <p>
          <router-link class="button is-primary" to="Tutorial">Start Tutorial</router-link>
        </p>
        <button class="button is-small" @click="windowReload()">Refresh Page</button>
      </div>

    </div>


    <!-- <div class="footer-nav">
      <router-link to="/" class="nav-previous">
        <div class="nav-text">Previous</div>
      </router-link>
      <a class="nav-previous"></a>
        <router-link to="/PageOne" class="nav-next">
          <div class="nav-text">Next</div>
        </router-link>
      <div class="clear"></div>
    </div> -->

  </div>


</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  methods: {

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    windowReload: function() {
      // let self = this;
      // let message = (method == 'reload' ? 'A user has force refreshed the app from the Dashboard (content loading...)' : 'A user has manually refreshed the app from the Dashboard');
      // var userHasEngaged = firebase.functions().httpsCallable('userHasEngaged');
      // userHasEngaged({
      //   userID: self.firebaseid ? self.firebaseid : 'no-id', 
      //   userName: self.firebasedisplayname ? self.firebasedisplayname : 'A visitor',
      //   message: message,
      //   subject: 'A user has refreshed the app'
      // }); 
      window.location.reload();
    },

  }
}
</script>


<style lang="scss" scoped> 

  h1 {
    margin: 1rem auto 2rem;
    color: #06c;
    padding: 0 1rem;
  }
  h4 {
    margin-bottom: 2rem;
  }
  p {
    margin-bottom: 1rem;
  }

</style>
